<template>
  <div class="row g-5 g-xl-8">
    <div class="col-12">
      <form class="form" @submit.prevent="handleSubmit">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-6">
            <div class="card-title">
              <div>
                <h3 class="fw-bolder mb-1">{{ pageTitle }}</h3>
                <div class="text-gray-500 fw-bold fs-7">
                  ฟอร์มข้อมูลสถานประกอบการ
                </div>
              </div>
            </div>
            <div class="card-toolbar">
              <router-link to="/profile" class="btn btn-light me-3">
                ยกเลิก
              </router-link>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isSubmitting || isLoading"
              >
                {{ isSubmitting ? "กำลังบันทึก..." : "บันทึกข้อมูล" }}
              </button>
            </div>
          </div>
        </div>

        <div class="card mb-5 mb-xl-8">
          <div class="card-body p-9">
            <section class="mb-10">
              <div class="mb-8">
                <h4 class="fw-bolder mb-2">ข้อมูล TSIC</h4>
                <div class="separator separator-dashed"></div>
              </div>

              <div class="row g-6">
                <div class="col-md-6">
                  <label class="form-label fw-bold required">TSIC-ID</label>
                  <input
                    v-model="form.tsicId"
                    type="text"
                    class="form-control form-control-solid"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold">TSIC-ID เก่า</label>
                  <input
                    v-model="form.oldTsicId"
                    type="text"
                    class="form-control form-control-solid"
                    readonly
                  />
                </div>
                <div class="col-12">
                  <label class="form-label fw-bold required">ประเภท TSIC</label>
                  <input
                    v-model="form.tsicType"
                    type="text"
                    class="form-control form-control-solid"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold required"
                    >ชื่อนิติบุคคล</label
                  >
                  <input
                    v-model="form.juristicName"
                    type="text"
                    class="form-control form-control-solid"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold required">
                    ชื่อสถานประกอบการ
                  </label>
                  <input
                    v-model="form.factoryName"
                    type="text"
                    class="form-control form-control-solid"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold required">หน่วยงาน</label>
                  <el-select
                    v-model="form.department"
                    class="w-100"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                  >
                    <el-option
                      v-for="option in departmentOptions"
                      :key="option.code"
                      :value="option.code"
                      :label="option.name"
                    />
                  </el-select>
                </div>
              </div>
            </section>

            <section class="mb-10">
              <div class="mb-8">
                <h4 class="fw-bolder mb-2">ประเภทสถานประกอบการ</h4>
                <div class="separator separator-dashed"></div>
              </div>

              <div class="row g-6">
                <div class="col-lg-4">
                  <label class="form-label fw-bold d-block required">
                    โรงงานควบคุม
                  </label>
                  <div class="d-flex flex-wrap gap-6">
                    <label
                      class="form-check form-check-custom form-check-solid"
                    >
                      <input
                        v-model="form.factoryControlType"
                        class="form-check-input"
                        type="radio"
                        value="โรงงาน"
                      />
                      <span class="form-check-label fw-semibold">โรงงาน</span>
                    </label>
                    <label
                      class="form-check form-check-custom form-check-solid"
                    >
                      <input
                        v-model="form.factoryControlType"
                        class="form-check-input"
                        type="radio"
                        value="อาคาร"
                      />
                      <span class="form-check-label fw-semibold">อาคาร</span>
                    </label>
                  </div>
                </div>
                <div class="col-lg-8">
                  <label class="form-label fw-bold required">
                    {{ activityLabel }}
                  </label>
                  <el-select
                    v-model="form.factoryBuildingType"
                    class="w-100"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                  >
                    <el-option
                      v-for="option in factoryTypeOptions"
                      :key="option.code"
                      :value="option.code"
                      :label="option.name"
                    />
                  </el-select>
                </div>
              </div>
            </section>

            <section class="mb-10">
              <div class="mb-8">
                <h4 class="fw-bolder mb-2">สถานที่ตั้ง</h4>
                <div class="separator separator-dashed"></div>
              </div>

              <div class="row g-6">
                <div class="col-md-6">
                  <label class="form-label fw-bold">เลขที่</label>
                  <input
                    v-model="form.no"
                    type="text"
                    class="form-control form-control-solid"
                    placeholder="กรุณาระบุเลขที่"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold">หมู่</label>
                  <input
                    v-model="form.moo"
                    type="text"
                    class="form-control form-control-solid"
                    placeholder="กรุณาระบุหมู่"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold">ตรอก/ซอย</label>
                  <input
                    v-model="form.soi"
                    type="text"
                    class="form-control form-control-solid"
                    placeholder="กรุณาระบุตรอก/ซอย"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold">ถนน</label>
                  <input
                    v-model="form.road"
                    type="text"
                    class="form-control form-control-solid"
                    placeholder="กรุณาระบุถนน"
                  />
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">ภาค</label>
                  <el-select
                    v-model="form.region"
                    class="w-100"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                    @change="handleRegionChange"
                  >
                    <el-option
                      v-for="option in regionOptions"
                      :key="option.code"
                      :value="option.code"
                      :label="option.name"
                    />
                  </el-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">จังหวัด</label>
                  <el-select
                    v-model="form.province"
                    class="w-100"
                    :disabled="!form.region"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="option in provinceOptions"
                      :key="option.code"
                      :value="option.code"
                      :label="option.name"
                    />
                  </el-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">อำเภอ/เขต</label>
                  <el-select
                    v-model="form.district"
                    class="w-100"
                    :disabled="!form.province"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                    @change="handleDistrictChange"
                  >
                    <el-option
                      v-for="option in districtOptions"
                      :key="option.code"
                      :value="option.code"
                      :label="option.name"
                    />
                  </el-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">ตำบล/แขวง</label>
                  <el-select
                    v-model="form.subDistrict"
                    class="w-100"
                    :disabled="!form.district"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                    @change="handleSubDistrictChange"
                  >
                    <el-option
                      v-for="option in subDistrictOptions"
                      :key="option.code"
                      :value="option.code"
                      :label="option.name"
                    />
                  </el-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">รหัสไปรษณีย์</label>
                  <input
                    v-model="form.zipcode"
                    type="text"
                    class="form-control form-control-solid"
                    readonly
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold required">โทรศัพท์</label>
                  <input
                    v-model="form.tel"
                    type="text"
                    inputmode="numeric"
                    maxlength="10"
                    class="form-control form-control-solid"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold">โทรสาร</label>
                  <input
                    v-model="form.fax"
                    type="text"
                    inputmode="numeric"
                    maxlength="10"
                    class="form-control form-control-solid"
                  />
                </div>
              </div>
            </section>

            <section>
              <div class="mb-8">
                <h4 class="fw-bolder mb-2">ข้อมูลทั่วไป</h4>
                <div class="separator separator-dashed"></div>
              </div>

              <div class="row g-6">
                <div class="col-md-3">
                  <label class="form-label fw-bold">
                    วันที่อนุมัติผลการวินิจฉัย
                  </label>
                  <input
                    v-model="form.approveDate"
                    type="date"
                    class="form-control form-control-solid"
                  />
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold required">กลุ่ม</label>
                  <el-select
                    v-model="form.group"
                    class="w-100"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                  >
                    <el-option
                      v-for="option in groupOptions"
                      :key="option.id"
                      :value="option.id"
                      :label="option.name"
                    />
                  </el-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">ชื่อ ACs</label>
                  <input
                    v-model="form.acsName"
                    type="text"
                    class="form-control form-control-solid"
                  />
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold required">อพ.</label>
                  <el-select
                    v-model="form.aopol"
                    class="w-100"
                    filterable
                    clearable
                    placeholder="กรุณาระบุ"
                  >
                    <el-option
                      v-for="option in aopolOptions"
                      :key="option.code"
                      :value="option.code"
                      :label="option.name"
                    />
                  </el-select>
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold required">
                    พลังงานทั้งหมดเทียบเท่าไฟฟ้า
                  </label>
                  <div class="input-group input-group-solid">
                    <input
                      v-model="form.electric"
                      type="text"
                      class="form-control"
                    />
                    <span class="input-group-text">MJ</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold required">
                    ขนาดการใช้หม้อแปลง
                  </label>
                  <div class="input-group input-group-solid">
                    <input
                      v-model="form.transformer"
                      type="text"
                      class="form-control"
                    />
                    <span class="input-group-text">kVA</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import axios from "axios";
import ReferenceDataApi from "@/core/services/ReferenceDataApi";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import router from "@/router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

type CodeNameOption = {
  code: string;
  name: string;
  provinceEn?: string;
  zipcode?: string;
};

type GroupOption = {
  id: string;
  name: string;
};

const createDefaultForm = () => ({
  id: "",
  tsicId: "",
  oldTsicId: "",
  tsicType: "",
  juristicName: "",
  factoryName: "",
  department: "",
  factoryControlType: "โรงงาน",
  factoryBuildingType: "",
  no: "",
  moo: "",
  soi: "",
  road: "",
  region: "",
  province: "",
  district: "",
  subDistrict: "",
  zipcode: "",
  tel: "",
  fax: "",
  approveDate: "",
  group: "",
  acsName: "",
  aopol: "",
  electric: "",
  transformer: "",
  enable: true,
  createDate: "",
  updateDate: "",
});

const DEFAULT_FACTORY_ID = "69f1750346e0fb0001795290";

export default defineComponent({
  name: "factory-manage",
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      trainingAccessToken: "",
      form: createDefaultForm(),
      regionOptions: [] as CodeNameOption[],
      provinceOptions: [] as CodeNameOption[],
      districtOptions: [] as CodeNameOption[],
      subDistrictOptions: [] as CodeNameOption[],
      factoryTypeOptions: [] as CodeNameOption[],
      departmentOptions: [] as CodeNameOption[],
      aopolOptions: [] as CodeNameOption[],
      groupOptions: [] as GroupOption[],
    };
  },
  computed: {
    factoryId(): string {
      return (this.$route.params.id as string) || DEFAULT_FACTORY_ID;
    },
    isEditMode(): boolean {
      return !!this.factoryId;
    },
    pageTitle(): string {
      return this.isEditMode
        ? "แก้ไขข้อมูลสถานประกอบการ"
        : "เพิ่มข้อมูลสถานประกอบการ";
    },
    activityLabel(): string {
      return this.form.factoryControlType === "อาคาร"
        ? "ประเภทอาคาร"
        : "ประเภทกิจการ";
    },
  },
  async mounted() {
    setCurrentPageBreadcrumbs(this.pageTitle, ["โปรไฟล์"]);
    await this.initializePage();
  },
  methods: {
    tokenHeader() {
      return {
        token: localStorage.getItem("id_token")
          ? localStorage.getItem("id_token")
          : localStorage.getItem("tokenGuest"),
      };
    },
    formatDateInput(dateValue: string | number | null): string {
      if (!dateValue) {
        return "";
      }

      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) {
        return "";
      }

      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    findOptionName(options: Array<CodeNameOption>, code: string): string {
      const item = options.find((option) => option.code === code);
      return item ? item.name : "";
    },
    async initializePage(): Promise<void> {
      this.isLoading = true;

      try {
        await this.fetchTrainingToken();
        await Promise.all([
          this.fetchFactoryBuildingTypes(),
          this.fetchFactoryDepartments(),
          this.fetchGroups(),
          this.fetchFactoryAopol(),
          this.fetchRegions(),
        ]);

        if (this.isEditMode) {
          await this.fetchFactory();
        } else {
          console.log("sdsadas");

          this.form.approveDate = this.formatDateInput(Date.now());
        }
      } catch (error) {
        this.showApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchTrainingToken(): Promise<void> {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/connectTrainingToken`,
        {
          headers: this.tokenHeader(),
        },
      );

      this.trainingAccessToken = response.data?.data?.access_token || "";
    },
    async fetchRegions(selectedCode = ""): Promise<void> {
      const response = await ReferenceDataApi.getRegions();

      this.regionOptions = (response.data?.data || []).map((item) => ({
        code: item.region_code,
        name: item.region_name_th,
      }));

      if (selectedCode) {
        this.form.region = selectedCode;
      }
    },
    async fetchProvinces(selectedCode = ""): Promise<void> {
      this.provinceOptions = [];
      this.districtOptions = [];
      this.subDistrictOptions = [];

      if (!this.form.region) {
        return;
      }

      const response = await ReferenceDataApi.getProvinces();

      this.provinceOptions = (response.data?.data || [])
        .filter((item) => item.region_code == this.form.region)
        .map((item) => ({
          code: item.province_code,
          name: item.province_name_th,
          provinceEn: item.province_name_en,
        }));

      if (selectedCode) {
        this.form.province = selectedCode;
      }
    },
    async fetchDistricts(selectedCode = ""): Promise<void> {
      this.districtOptions = [];
      this.subDistrictOptions = [];

      if (!this.form.province) {
        return;
      }

      const response = await ReferenceDataApi.getDistricts(this.form.province);

      this.districtOptions = (response.data?.data || []).map((item) => ({
        code: item.district_code,
        name: item.district_name_th,
      }));

      if (selectedCode) {
        this.form.district = selectedCode;
      }
    },
    async fetchSubDistricts(selectedCode = ""): Promise<void> {
      this.subDistrictOptions = [];

      if (!this.form.province || !this.form.district) {
        return;
      }

      const response = await ReferenceDataApi.getSubDistricts(
        this.form.province,
        this.form.district,
      );

      this.subDistrictOptions = (response.data?.data || []).map((item) => ({
        code: item.sub_district_code,
        name: item.sub_district_name_th,
        zipcode: item.postcode,
      }));

      if (selectedCode) {
        this.form.subDistrict = selectedCode;
        const selected = this.subDistrictOptions.find(
          (item) => item.code === selectedCode,
        );
        this.form.zipcode = selected?.zipcode || this.form.zipcode;
      }
    },
    async fetchFactoryBuildingTypes(): Promise<void> {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/getFactoryBuildingTypes`,
        {
          headers: this.tokenHeader(),
        },
      );

      this.factoryTypeOptions = (response.data?.data || []).map((item) => ({
        code: item.code,
        name: item.name,
      }));
    },
    async fetchFactoryDepartments(): Promise<void> {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/getFactoryDepartments`,
        {
          headers: this.tokenHeader(),
        },
      );

      this.departmentOptions = (response.data?.data || []).map((item) => ({
        code: item.code,
        name: item.name,
      }));
    },
    async fetchGroups(): Promise<void> {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/getGroup`,
        {
          headers: this.tokenHeader(),
        },
      );

      this.groupOptions = (response.data?.data || []).map((item) => ({
        id: `${item.groupId}`,
        name: item.groupName,
      }));
    },
    async fetchFactoryAopol(): Promise<void> {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/getFactoryAopol`,
        {
          headers: this.tokenHeader(),
        },
      );

      this.aopolOptions = (response.data?.data || []).map((item) => ({
        code: item.code,
        name: item.name,
      }));
    },
    async fetchFactory(): Promise<void> {
      console.log("fetchFactory");
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/getFactory`,
        {
          headers: this.tokenHeader(),
          params: {
            facId: this.factoryId,
          },
        },
      );

      const data = response.data?.data?.content?.[0];
      if (!data) {
        return;
      }
      this.form.id = data.id || "";
      this.form.tsicId = data.tsicId || "";
      this.form.oldTsicId = data.oldTsicId || "";
      this.form.tsicType = data.tsicType || "";
      this.form.juristicName = data.juristicName || "";
      this.form.factoryName = data.factoryName || "";
      this.form.department = data.depId || "";
      this.form.factoryControlType = data.type || "โรงงาน";
      this.form.factoryBuildingType = data.facBuildTypeId || "";
      this.form.tel = data.tel || "";
      this.form.fax = data.fax || "";
      this.form.approveDate = this.formatDateInput(data.approveDate);
      this.form.group = data.factoryGroupId ? `${data.factoryGroupId}` : "";
      this.form.acsName = data.acsName || "";
      this.form.aopol = data.factoryAopolId || "";
      this.form.electric = data.electric || "";
      this.form.transformer = data.transformer || "";
      this.form.enable = data.enable !== false;
      this.form.createDate = data.createDate || "";
      this.form.updateDate = data.updateDate || "";

      if (data.addressFac) {
        this.form.no = data.addressFac.no || "";
        this.form.road = data.addressFac.road || "";
        this.form.moo = data.addressFac.moo || "";
        this.form.soi = data.addressFac.soi || "";
        this.form.zipcode = data.addressFac.zipcode || "";
        this.form.region = data.addressFac.regionCode || "";

        await this.fetchProvinces(data.addressFac.provinceCode || "");
        await this.fetchDistricts(data.addressFac.districtCode || "");
        await this.fetchSubDistricts(data.addressFac.subDistrictCode || "");
      }

      if (!this.form.approveDate) {
        this.form.approveDate = this.formatDateInput(Date.now());
      }
    },
    async handleRegionChange(): Promise<void> {
      this.form.province = "";
      this.form.district = "";
      this.form.subDistrict = "";
      this.form.zipcode = "";
      await this.fetchProvinces();
    },
    async handleProvinceChange(): Promise<void> {
      this.form.district = "";
      this.form.subDistrict = "";
      this.form.zipcode = "";
      await this.fetchDistricts();
    },
    async handleDistrictChange(): Promise<void> {
      this.form.subDistrict = "";
      this.form.zipcode = "";
      await this.fetchSubDistricts();
    },
    handleSubDistrictChange(): void {
      const selected = this.subDistrictOptions.find(
        (option) => option.code === this.form.subDistrict,
      );
      this.form.zipcode = selected?.zipcode || "";
    },
    validateForm(): string | null {
      this.form.tel = this.form.tel.replace(/-/g, "");
      this.form.fax = this.form.fax.replace(/-/g, "");
      if (!this.form.tsicId) return "กรุณาระบุ TSIC-ID";
      if (!this.form.tsicType) return "กรุณาระบุประเภท TSIC";
      if (!this.form.juristicName) return "กรุณาระบุชื่อนิติบุคคล";
      if (!this.form.factoryName) return "กรุณาระบุชื่อสถานประกอบการ";
      if (!this.form.department) return "กรุณาเลือกหน่วยงาน";
      if (!this.form.factoryBuildingType)
        return `กรุณาเลือก${this.activityLabel}`;
      if (!this.form.tel) return "กรุณาระบุโทรศัพท์";
      if (this.form.tel.length > 10) return "โทรศัพท์ต้องไม่เกิน 10 หลัก";
      if (this.form.fax && this.form.fax.length > 10)
        return "โทรสารต้องไม่เกิน 10 หลัก";
      if (!this.form.group) return "กรุณาเลือกกลุ่ม";
      if (!this.form.aopol) return "กรุณาเลือก อพ.";
      if (!this.form.electric) return "กรุณาระบุพลังงานทั้งหมดเทียบเท่าไฟฟ้า";
      if (!this.form.transformer) return "กรุณาระบุขนาดการใช้หม้อแปลง";
      return null;
    },
    buildFormData(): FormData {
      const formData = new FormData();

      formData.append("tsicId", this.form.tsicId);
      formData.append("oldTsicId", this.form.oldTsicId);
      formData.append("tsicType", this.form.tsicType);
      formData.append("juristicName", this.form.juristicName);
      formData.append("factoryName", this.form.factoryName);
      formData.append("depId", this.form.department);
      formData.append("type", this.form.factoryControlType);
      formData.append("facBuildTypeId", this.form.factoryBuildingType);
      formData.append("tel", this.form.tel);
      formData.append("fax", this.form.fax);
      formData.append(
        "approveDate",
        new Date(this.form.approveDate || Date.now()).getTime().toString(),
      );
      formData.append("factoryGroupId", this.form.group);
      formData.append("acsName", this.form.acsName);
      formData.append("factoryAopolId", this.form.aopol);
      formData.append("electric", this.form.electric);
      formData.append("transformer", this.form.transformer);
      formData.append("enable", String(this.form.enable));

      if (this.form.region) {
        formData.append("regionCode", this.form.region);
        formData.append(
          "regionTh",
          this.findOptionName(this.regionOptions, this.form.region),
        );
      }

      if (this.form.province) {
        const province = this.provinceOptions.find(
          (option) => option.code === this.form.province,
        );
        formData.append("provinceCode", this.form.province);
        formData.append("provinceTh", province?.name || "");
        formData.append("provinceEn", province?.provinceEn || "");
      }

      if (this.form.district) {
        formData.append("districtCode", this.form.district);
        formData.append(
          "districtTh",
          this.findOptionName(this.districtOptions, this.form.district),
        );
      }

      if (this.form.subDistrict) {
        formData.append("subDistrictCode", this.form.subDistrict);
        formData.append(
          "subDistrictTh",
          this.findOptionName(this.subDistrictOptions, this.form.subDistrict),
        );
        formData.append("zipcode", this.form.zipcode);
      }

      formData.append("road", this.form.road);
      formData.append("no", this.form.no);
      formData.append("moo", this.form.moo);
      formData.append("soi", this.form.soi);

      if (this.isEditMode) {
        formData.append("id", this.form.id || "");
        formData.append("updateDate", Date.now().toString());
      }

      return formData;
    },
    async handleSubmit(): Promise<void> {
      const validationError = this.validateForm();
      if (validationError) {
        Swal.fire({
          title: "ข้อมูลไม่ครบถ้วน",
          text: validationError,
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-warning",
          },
        });
        return;
      }

      this.isSubmitting = true;
      Swal.fire({
        title: "กำลังบันทึกข้อมูล...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/addEditFactory`,
            this.buildFormData(),
            {
              headers: this.tokenHeader(),
            },
          )
          .then(async (response) => {
            if (response.data.code == 200) {
              Swal.fire({
                title: "บันทึกข้อมูลสำเร็จ",
                text:
                  response.data.message || "ข้อมูลโรงงานถูกบันทึกเรียบร้อยแล้ว",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "ตกลง",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-success",
                },
              });
              router.push({ name: "profile" });
            } else {
              throw new Error(
                response.data.message || "ไม่สามารถบันทึกข้อมูลโรงงานได้",
              );
            }
          })
          .catch((error) => {
            throw error;
          });
      } catch (error) {
        this.showApiError(error);
      } finally {
        this.isSubmitting = false;
      }
    },
    showApiError(error): void {
      const message =
        error?.response?.data?.message || "กรุณาตรวจสอบใหม่อีกครั้ง";

      Swal.fire({
        title: "แจ้งเตือนข้อผิดพลาด",
        text: message,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "ตกลง",
        customClass: {
          confirmButton: "btn fw-semobold btn-light-danger",
        },
      });
    },
  },
});
</script>
